import { useSelector } from "../store";
import { useIsHostedCluster } from "./use-is-hosted-cluster";

const PERSONAL_ORG_TYPE = "personal";

/**
 * Hook to check if policy creation/editing should be restricted.
 * Returns true when the current cluster is a hosted cluster AND
 * the organization type is "personal".
 */
export const usePolicyRestrictedInHostedCluster = (): boolean => {
  const isHostedCluster = useIsHostedCluster();
  const { organizationId } = useSelector((state) => state.current);
  const { byId } = useSelector((state) => state.organizations);
  const { organizationType = PERSONAL_ORG_TYPE } = byId[organizationId];

  return isHostedCluster && organizationType === PERSONAL_ORG_TYPE;
};
